import React, { useCallback } from 'react'
import { AppState } from '../../../stores/app'
import { useService } from '@pushly/aqe/lib/hooks'
import { DomainNotificationBuilderView } from '../../../components/notification-builder/views/domain-notification-builder-view'

export const BuildNamedNotificationTemplate = () => {
    const domain = useService(AppState).currentDomain!

    const getParentRoute = useCallback(() => {
        return `/domains/${domain.id}/notifications/templates`
    }, [domain.id])

    return (
        <DomainNotificationBuilderView
            formMode="create"
            formType="named-template"
            showTemplateDetails={true}
            hideTemplateSelector={true}
            hideVariantManager={true}
            hideScheduling={true}
            hideDevicePreviewAction={true}
            getParentRoute={getParentRoute}
        />
    )
}
